import {
  connectStorageEmulator,
  getDownloadURL,
  getStorage,
  ref,
  uploadBytes,
  type UploadMetadata,
} from "firebase/storage";
import { config } from "@/config";
import { firebase } from "./firebase";

const firebaseStorage = getStorage(firebase);

const storage = {
  getDownloadURL: async (path: string) => {
    const storageRef = ref(firebaseStorage, path);
    try {
      const url = new URL(await getDownloadURL(storageRef));

      // remove token param from url
      url.searchParams.delete("token");
      const search = url.searchParams.toString();

      return url.origin + url.pathname + (search ? "?" + search : "");
    } catch (err) {
      return "";
    }
  },

  upload: async (
    file: File | Blob,
    path: string,
    metadata?: UploadMetadata["customMetadata"]
  ) => {
    const storageRef = ref(firebaseStorage, path);
    await uploadBytes(
      storageRef,
      file,
      metadata ? { customMetadata: metadata } : undefined
    );
    return await storage.getDownloadURL(path);
  },
};

if (config.emulator) {
  connectStorageEmulator(firebaseStorage, "localhost", 9199);
}

export { storage };
